import { Navigate, useLocation, type To } from 'react-router-dom';
import { buildCramPath, paths } from '@shared/config';
import { campaignSearch } from '@shared/lib/campaignParams';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Куда ведёт ссылка из письма-напоминания. Метки кампании переносим: просмотр Метрики уходит уже
 *  с итогового адреса (AnalyticsTracker), а rid засчитан при старте приложения (reportReminderClick). */
function repeatTarget(search: string): To {
  const moduleId = new URLSearchParams(search).get('module')?.trim() ?? '';
  const labels = campaignSearch(search).slice(1);
  if (!UUID.test(moduleId)) return { pathname: paths.training, search: campaignSearch(search) };
  return { pathname: buildCramPath(moduleId), search: `?preset=warmup&n=10&boss=0${labels ? `&${labels}` : ''}` };
}

/**
 * /repeat?module=<id> — цель ссылки из письма-напоминания (A). Пока ведёт в конструктор тренировки
 * модуля: 10 карточек и без финального матча — поверх сохранённого состава (решения 2026-10-19 и
 * 2026-10-20, B1: письмо обещает 10); «Разминка» — если у модуля нет сохранённых упражнений. Позже G
 * заменит это умным стартом без смены ссылок в отправленных письмах. Гость сюда вернётся после входа (Ф0).
 */
export default function RepeatPage() {
  const { search } = useLocation();
  return <Navigate to={repeatTarget(search)} replace />;
}
